import React from 'react';
import SelectSingle from './SelectSingle';

interface Props {
  value: string | null | undefined;
  onChange: (pipeline: string) => void;
  readOnly?: boolean;
}

export type PitchType = {
  model: string;
  name: string;
};

const pitchTypes: Array<PitchType> = [
  { model: 'FullPitchExtendedModel', name: 'Full football pitch with extra 16m points' },
  { model: 'FullPitchModel', name: 'Full football' },
  { model: 'FutsalModel', name: 'Futsal' },
  { model: 'FutsalModelExtended', name: 'Futsal extended' },
  { model: 'FutsalModel15', name: 'Futsal model with extra points' },
  { model: 'HockeyPitchModel', name: 'Full size field hockey' },
];

const SelectSinglePitchType: React.FunctionComponent<Props> = (props) => {
  const selected = pitchTypes.find((p) => p.model === props.value) || undefined;

  const onChange = (value: PitchType | undefined) => {
    if (value && value.model) {
      props.onChange(value.model);
    }
  };

  return props.readOnly ? (
    <span>{selected ? selected.name : '-'}</span>
  ) : (
    <SelectSingle<PitchType>
      selected={selected}
      onChange={onChange}
      data={pitchTypes}
      isClearable={false}
      label="Pitch layouts"
      placeholder="Select pitch layout"
      optionLabel={(pl) => (pl ? pl.name : '-')}
      optionValue={(pl) => (pl ? pl.model : '-')}
    />
  );
};

export default SelectSinglePitchType;
